import { Grid, Paper } from '@material-ui/core';
import Chart from '../../../components/MasterComponent/EchartsSetup/Echarts';
import CustomLegend from '../../../components/MasterComponent/EchartsSetup/CustomLegend';
import GraphLoader from '../../../components/ServicesReports/GraphLoader';

interface ChartCardProps {
    title: string;
    data: Record<string, any>;
    isSubmitting: boolean;
    generateColors: (count: number) => string[];
    getChartOptions: (data: Record<string, any>) => echarts.EChartsOption;
    onChartInit: (chart: echarts.ECharts | null) => void;
    chartInstance: echarts.ECharts | null;
    classes: Record<string, string>;
    legendHeading?: string; 
    actionElement?: React.ReactNode; 
    hideHeader?: boolean;
}

/**
 * ChartCard: reusable sub-component for a single chart box
 */
const ChartCard: React.FC<ChartCardProps> = ({
  title,
  data,
  isSubmitting,
  generateColors,
  getChartOptions,
  onChartInit,
  chartInstance,
  classes,
  legendHeading,
  actionElement,
  hideHeader
}) => {
    return (
        <Paper elevation={3} className={classes.paper} style={{
                borderTopLeftRadius: hideHeader ? 0 : undefined,
                borderTopRightRadius: hideHeader ? 0 : undefined,
            }} 
        >
            <Grid container direction="column" spacing={0}>
                {!hideHeader && (
                    <Grid item>
                        <Grid container justify="space-between" alignItems="center" className={classes.headerRow}>
                            <Grid item className={classes.chartTitle}>
                            {title}
                            </Grid>
                            <Grid item>
                            {actionElement}
                            </Grid>
                        </Grid>
                    </Grid>
                )}

                <Grid item className={classes.barContainer}>
                {isSubmitting ? (
                    <GraphLoader
                    style={{
                        height: '41vh',
                        width: '91%',
                        margin: '5rem auto',
                    }}
                    isLoading
                    />
                ) : (
                    <>
                    <Chart
                        option={getChartOptions(data)}
                        style={{ height: '54vh', width: '100%' }}
                        onChartInit={onChartInit}
                    />
                    {legendHeading && (
                        <div className="legendHeading">{legendHeading}</div>
                    )}
                    <CustomLegend
                        legendData={data && Object.keys(data)}
                        colors={generateColors(Object.keys(data || {}).length)}
                        chartInstance={chartInstance}
                    />
                    </>
                )}
                </Grid>
            </Grid>
        </Paper>
    );
};

export default ChartCard;